import { RegItemMinimal } from 'src/types/regItem'
import getRegItemType from '../../../../utils/getRegItemType/getRegItemType'
import {
  CashFundDetails,
  ExternalRegistryDetails,
  GiftCardDetails,
  GroupGiftDetails,
  HelpAndFavorDetails,
  ProductDetails,
} from './variants'
import {
  REG_ITEM_TYPE_CROWDFUND,
  REG_ITEM_TYPE_EXTERNAL_REGISTRY,
  REG_ITEM_TYPE_FAVOR,
  REG_ITEM_TYPE_GIFT_CARD,
  REG_ITEM_TYPE_GROUP_GIFT,
  REG_ITEM_TYPE_PRODUCT,
} from 'src/constants'

export const getRegItemDetailsComponent = (regItem: RegItemMinimal) => {
  const regItemType = getRegItemType(regItem)

  switch (regItemType) {
    case REG_ITEM_TYPE_CROWDFUND:
      return CashFundDetails
    case REG_ITEM_TYPE_GIFT_CARD:
      return GiftCardDetails
    case REG_ITEM_TYPE_EXTERNAL_REGISTRY:
      return ExternalRegistryDetails
    case REG_ITEM_TYPE_FAVOR:
      return HelpAndFavorDetails
    case REG_ITEM_TYPE_GROUP_GIFT:
      return GroupGiftDetails
    case REG_ITEM_TYPE_PRODUCT:
      return ProductDetails
    default:
      return ProductDetails
  }
}
